function InsuranceStatementVO(id, issueDate, type, ableToAttendExamination, examinationReason, treatmentDescription,
                              additionalResultsAndConclusions, prognostics, attachments, visitCard, mainDiagnosis,
                              diagnosisList, alreadyPrinted) {
    this.id = id;

    this.issueDate = issueDate;
    this.type = type;
    this.ableToAttendExamination = ableToAttendExamination;
    this.examinationReason = examinationReason;
    this.treatmentDescription = treatmentDescription;
    this.additionalResultsAndConclusions = additionalResultsAndConclusions;
    this.prognostics = prognostics;
    this.attachments = attachments;
    this.visitCard = visitCard;
    this.mainDiagnosis = mainDiagnosis;
    this.diagnosisList = diagnosisList;
    this.alreadyPrinted = alreadyPrinted;

    var _typeContext = {
        issueDate: Date,
        visitCard: VisitCardVO,
        mainDiagnosis: DictionaryVO,
        diagnosisList: DictionaryVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}